import * as React from 'react';

export default function IconConnectWithShopee({
  className,
}: {
  className?: string;
}) {
  return (
    <svg fill="none" viewBox="0 0 25 24" className={className}>
      <path
        fillRule="evenodd"
        d="M16.235 17.468c-.132 1.063-.793 1.915-1.817 2.341-.57.237-1.334.365-1.939.325-.942-.035-1.827-.259-2.642-.667-.297-.149-.732-.442-1.06-.71-.075-.061-.113-.116-.041-.215l.428-.614c.065-.096.17-.101.268-.027l.132.1c.785.599 1.798 1.049 2.923 1.091 1.419-.019 2.449-.639 2.632-1.599.203-1.058-.658-1.966-2.315-2.472-.527-.161-1.852-.678-2.096-.818-1.155-.66-1.693-1.526-1.616-2.592.117-1.477 1.522-2.584 3.306-2.591.847-.002 1.64.181 2.348.472.26.107.745.362.918.487.121.086.111.183.064.258l-.364.568c-.062.091-.138.102-.246.035a5.01 5.01 0 0 0-2.694-.816c-1.218.024-2.137.729-2.197 1.696-.016.874.665 1.508 2.111 1.992 2.985.935 4.116 2.033 3.902 3.756zM12.551 2.285c1.932 0 3.507 1.787 3.581 4.023H8.971c.074-2.237 1.649-4.023 3.581-4.023zm9.571 4.023h-4.642C17.367 3.355 15.203 1 12.551 1S7.736 3.355 7.622 6.308H2.974c-.233.004-.421.191-.421.42l.001.033h-.003l.663 14.233.005.12.002.027.001.03.002.002c.101.99.838 1.788 1.841 1.825l.002.002h14.746.021.021.031c1.021-.027 1.848-.837 1.935-1.839l.001-.014.002-.032.003-.075.723-14.29v-.022c0-.232-.192-.42-.429-.42z"
        fill="#ee4d2d"
      />
    </svg>
  );
}
